import React, { Component } from 'react';
import { FlexibleContainer } from 'components/shared/FlexibleContainer';
import GroupsGrid from 'components/GroupsGrid';
import AccountsGrid from 'components/AccountsGrid';

import { GROUPS_ACCOUNTS_PATH } from 'constants/paths';

class GroupsAccounts extends Component {
  render() {
    return (
      <FlexibleContainer orientation="vertical">
        <GroupsGrid path={GROUPS_ACCOUNTS_PATH} />
        <AccountsGrid path={GROUPS_ACCOUNTS_PATH} draggable={true} />
      </FlexibleContainer>
    );
  }
}

export default GroupsAccounts;
